import {
    useMutation,
} from '@tanstack/react-query'

import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Contact.requests'

import {
    Contact,
} from '../Contacts.types'

type Props = {
    onSuccess: (contact: { id: number }, payload: Contact) => void
}

const useCreateContact = ({
    onSuccess,
}: Props) => {
    const token = useJWTToken()

    const {
        onSuccess: onSuccessCreateCompany,
        onError,
    } = useHandleStatusRequest({
        title: 'New contact was created',
        id: 'ContactCreated',
        onSuccess,
    })

    const {
        mutate,
    } = useMutation({
        mutationFn: (contact: Contact) => {
            return simpleApi({
                ...requests.create({
                    data: contact,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessCreateCompany,
    })

    return mutate
}

export default useCreateContact
